import { useEffect } from 'react';

// Renderowany na koncu KAZDEJ crawlowanej publicznej strony. Ustawia atrybut na <body> gdy
// prawdziwa tresc strony jest zamontowana (nie fallback Suspense) - react-snap czeka na ten
// atrybut przez "waitFor" w package.json zamiast polegac wylacznie na domyslnym timingu sieci
// networkidle0, ktory NIE gwarantuje ze lazy-loadowany chunk strony juz sie wykonal.
export default function PrerenderReady() {
  useEffect(() => {
    document.body.setAttribute('data-prerender-ready', 'true');
    return () => document.body.removeAttribute('data-prerender-ready');
  }, []);
  return null;
}
